import { ParamMap } from '@angular/router';

import { Filter } from '../../../../pages/equipment/devices/components/devices.models';
import { FilterModels } from '../services/listing-page-model/listing-page-model.types';
import { mapFilterModelsToFilters } from './filters.helper';

export function mapQueryParamsToFilters(filterModels: FilterModels, queryParamMap: ParamMap): Filter[] {
  return mapFilterModelsToFilters(filterModels).reduce((acc: Filter[], { filterType }) => {
    const cachedValue = queryParamMap.getAll(filterType);
    return [
      ...acc,
      ...(cachedValue.length > 0
        ? [
            {
              filterType,
              filteredValues: cachedValue.length > 1 ? cachedValue : cachedValue[0].split(',')
            } as Filter
          ]
        : [])
    ];
  }, []);
}

/**
 * Picks the filter state a listing page starts with: URL query params win over the
 * previously persisted state, falling back to the filter models' own defaults for
 * anything the URL does not carry.
 */
export function getInitialFilters(
  stateFilters: Filter[],
  filterModels: FilterModels,
  queryParamMap: ParamMap
): Filter[] {
  const queryParamsFilters: Filter[] = mapQueryParamsToFilters(filterModels, queryParamMap);
  if (queryParamsFilters.length) {
    const defaultFilters = mapFilterModelsToFilters(filterModels);
    return defaultFilters.map(filter => {
      const cachedValueFound = queryParamsFilters.find(value => value.filterType === filter.filterType);
      return {
        ...filter,
        filteredValues: cachedValueFound ? cachedValueFound.filteredValues : filter.filteredValues
      };
    });
  }
  return stateFilters;
}
